import store from '../store';

export class DotsPina {
  constructor(data = []) {
    this.setDotsData(data);
  }
  setDotsData(res) {
    if (res.length === 0) {
      return;
    }
    console.log({
      信息牌: res.filter((o) => o.type === 1),
    });
    this.setRotateCarData(res.filter((o) => o.type === 3));
    this.setDots(res.filter((o) => o.type === 2));
  }
  // 锚点交互用
  setDots(dotData) {
    console.log({
      交互锚点: dotData,
    });
    dotData.length > 0 && store.commit('specDot/setDotsList', dotData);
  }
  setRotateCarData(rotateCarData) {
    console.log({
      主打车: rotateCarData,
    });
    rotateCarData.length > 0 &&
      store.commit('specDot/setRotateCarData', rotateCarData);
  }
  setPanoIds(panoIds) {
    console.log('主打车panoIds: ', panoIds);
    store.commit('specDot/setRotateCarPanoIds', panoIds);
  }
}
